import React from 'react';
import { useRenderedRecaptchaV2 } from '../../hooks/useRecaptcha';
import { CONFIG } from '../../config';

import './ContactToPurchaseForm.scss';

type Props = { setCanSubmit: (value: boolean) => void };

export const ContactToPurchaseFormRecaptcha: React.FC<Props> = ({ setCanSubmit }) => {
  useRenderedRecaptchaV2(
    'contactToPurchaseRecaptcha',
    () => setCanSubmit(true),
    CONFIG.SPECTACULAR_FORM_RECAPTCHA_KEY
  );

  return <div id="contactToPurchaseRecaptcha" />;
};
